export const STORE_IDS = {
  production: ['90262CKL','CKL89999', 'CKL89998', '99974', 'CKL47948'],
  testbed: ['90262CKL', 'BCC10000KUL', 'SWK50034', '99974', 'CKL47948']
};

export const MATERIAL_CODES = {
  'Blank Sim': ['20012802', '20015621', '20009721', '20012352'],
  'eSIM': ['ESIM030001'],
};

export const getMaterialCodeSuggestions = (itemType) => {
  return MATERIAL_CODES[itemType] || [];
};

export const getStoreIdSuggestions = (environment) => {
  if (!environment) return [];
  return STORE_IDS[environment] || [];
};
